module.exports = __webpack_public_path__ + "static/play-small-60207c4a88a01541f79519b7ee61dc8d.webp";